import { createTheme } from '@mui/material/styles'

interface ToastColorSet {
  background: string
  border: string
}

interface ToastPalette {
  success: ToastColorSet
  error: ToastColorSet
  warning: ToastColorSet
  info: ToastColorSet
}

declare module '@mui/material/styles' {
  interface PaletteColor {
    translucent?: string
    sub?: string
  }
  interface SimplePaletteColorOptions {
    translucent?: string
    sub?: string
  }
  interface Palette {
    toast: ToastPalette
  }
  interface PaletteOptions {
    toast?: ToastPalette
  }
}

export const themeMedilab = createTheme({
  palette: {
    primary: {
      main: '#D9E5FF',
      dark: '#303f9f',
      light: '#e3f2fd',
      translucent: 'rgba(48, 63, 159, 0.8)',
    },
    secondary: {
      main: '#B9B9B9',
      dark: '#616060',
      light: '#E5E5E5',
      sub: '#525252',
    },
    warning: {
      main: '#D00000',
      light: '#F1CFCF',
    },
    success: {
      main: '#4CAF50',
    },
    toast: {
      success: {
        background: 'rgba(76, 175, 80, 0.85)',
        border: 'rgba(76, 175, 80, 0.5)',
      },
      error: {
        background: 'rgba(208, 0, 0, 0.85)',
        border: 'rgba(208, 0, 0, 0.5)',
      },
      warning: {
        background: 'rgba(208, 0, 0, 0.85)',
        border: 'rgba(208, 0, 0, 0.5)',
      },
      info: {
        background: 'rgba(97, 97, 97, 0.9)',
        border: 'rgba(97, 97, 97, 0.6)',
      },
    },
  },
})

export const themeTMN = createTheme({
  palette: {
    primary: {
      main: '#1aa9e9',
      dark: '#1aa9e9',
      light: '#e3f2fd',
      translucent: 'rgba(48, 63, 159, 0.8)',
    },
    secondary: {
      main: '#B9B9B9',
      dark: '#616060',
      light: '#E5E5E5',
      sub: '#525252',
    },
    warning: {
      main: '#D00000',
      light: '#F1CFCF',
    },
    toast: {
      success: {
        background: 'rgba(76, 175, 80, 0.85)',
        border: 'rgba(76, 175, 80, 0.5)',
      },
      error: {
        background: 'rgba(208, 0, 0, 0.85)',
        border: 'rgba(208, 0, 0, 0.5)',
      },
      warning: {
        background: 'rgba(208, 0, 0, 0.85)',
        border: 'rgba(208, 0, 0, 0.5)',
      },
      info: {
        background: 'rgba(97, 97, 97, 0.9)',
        border: 'rgba(97, 97, 97, 0.6)',
      },
    },
  },
})
